import type { LeadTimeCalculatorInput } from '@calculations/lead-time/input';
import type { Decimal } from '@snap-types/types/decimal';

import { calculateTotalLeadTime } from './calculations/total-lead-time';
import {
  QuantityAware,
  QuantityAwareLeadTimeStrategy,
  QuantityAwareLeadTimeStrategyResult,
} from './types';

export function runQuantityAwareStrategy(
  quantity: Decimal,
  strategy: QuantityAwareLeadTimeStrategy,
  { quantityAwareInputs }: LeadTimeCalculatorInput,
): QuantityAwareLeadTimeStrategyResult {
  if (!quantityAwareInputs) {
    return { name: QuantityAware, weeks: null };
  }

  const result = calculateTotalLeadTime(
    quantity,
    quantityAwareInputs,
    strategy.config,
  );

  return {
    name: QuantityAware,
    weeks: result,
  };
}
